import { Navigate } from "react-router";

import { navigation } from "@src/shared/navigation";

export function meta() {
  return [
    { title: "Dashboard" },
    { name: "description", content: "Welcome to React Router!" },
  ];
}

export async function clientLoader() {
  return {};
}

export default function Dashboard() {
  return <Navigate to={navigation.patients()} />;
}
